import React, { Component } from "react";
import BaksetItem from "../components/BasketItem";
import { Button, Spinner, Modal, Form } from "react-bootstrap";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
// import dataa from '../data.json';
import { Redirect } from "react-router-dom";
import { MagicSpinner } from "react-spinners-kit";
import basketTitle from "../assets/basketTitle.png";

export default class Baskets extends Component {
  constructor(props) {
    super(props);

    this.scrolltobottom = this.scrolltobottom.bind(this);
    this.getBasketList = this.getBasketList.bind(this);
    this.deleteApi = this.deleteApi.bind(this);
    this.saveBaskets = this.saveBaskets.bind(this);

    this.state = {
      mobile: "",
      basketData: [],
      hideDialog: false,
      hideDialog1: false,
      token: "",
      serverResponse: false,
      modalBackDrop: "true",
      editProfile: false,
      ModalShow: false,
      archiveBasket: false,
      shareBasket: false,
      currentBasketId: "",
      currentBasketName: "",
      apiHasError: false,
      buttonDisabled: false,
      buttonDisabledArchive: true,
      anyBasketVisible: false,
      isLoading: false,
      buttonSpinner: false,
      backButtonDisabled: false,
      backButtonSpinner: false,
    };

    this.buttons = [
      {
        buttonModel: {
          content: "بله",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({ hideDialog: false });
          this.setState({ hideDialog1: true });
        },
      },
      {
        buttonModel: {
          content: "خیر",
          cssClass: "e-flat",
        },
        click: () => {
          this.setState({ hideDialog: false });
        },
      },
    ];

    this.buttons1 = [
      {
        buttonModel: {
          content: "اشتراک گذاری",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({ hideDialog1: false });
        },
      },
      {
        buttonModel: {
          content: "انصراف",
          cssClass: "e-flat",
        },
        click: () => {
          this.setState({ hideDialog1: false });
        },
      },
    ];
  }

  header() {
    return (
      <div style={{ direction: "rtl", textAlign: "right", marginTop: "10px" }}>
        اشتراک گذاری سبد
      </div>
    );
  }

  nextClick() {
    this.saveBaskets("next");
  }

  backClick() {
    this.saveBaskets("back");
  }

  componentDidMount() {
    if (!this.props.inModal) this.props.onBasketLoad();
    this.getBasketList();
  }

  getBasketList() {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
    };

    fetch("/api/basketList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        this.setState({ isLoading: false });
        if (resultt.status === 200) {
          this.setState({ basketData: resultt.result });
          let anyBasketVisible = false;
          resultt.result.forEach(function (entry) {
            if (entry.status === 2) anyBasketVisible = true;
          });
          this.setState({ anyBasketVisible: anyBasketVisible });
        } else {
          this.setState({ apiHasError: true });
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        this.setState({ apiHasError: true });
      });
  }

  deleteItem(id, name, balance) {
    if (this.props.inModal || (!this.props.inModal && balance > 0)) {
      this.setState({
        currentBasketId: id,
        currentBasketName: name,
        ModalShow: true,
        archiveBasket: true,
        shareBasket: false,
        buttonDisabledArchive: true,
      });
    } else {
      // let basket = this.state.basketData.slice()
      // let i=0;
      // let index=-1;
      // basket.forEach(function(entry) {
      //     if (entry.id===id){
      //         index=i;
      //     }
      //     i++;
      // });
      // if (index !== -1) {
      //     basket.splice(index, 1);
      //     this.setState({basketData: basket})
      // }
      this.deleteApi(id);
    }
  }

  deleteApi(id) {
    try {
      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        basket_id: id,
      };

      this.setState({ buttonDisabledArchive: true });
      fetch("/api/deleteBasket", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.status >= 200 && result.status < 300) {
            let basket = this.state.basketData.slice();
            let i = 0;
            let index = -1;
            basket.forEach(function (entry) {
              if (entry.id === id) {
                index = i;
              }
              i++;
            });
            if (index !== -1) {
              basket.splice(index, 1);
              this.setState({ basketData: basket });
            }

            if (this.state.ModalShow) this.hideModal();
            if (this.props.inModal) this.props.hideModal();
          }
          this.setState({ buttonDisabledArchive: false });
        });
    } catch (error) {}
  }

  editItem(id, name, des) {
    if (des === null || des === "" || des === undefined) des = 100;
    let basket = this.state.basketData.slice(); //copy the array
    basket.forEach(function (entry) {
      if (entry.id === id) {
        entry.lable = name;
        entry.percent = des;
        entry.Edited = true;
      }
    });

    this.setState({ basketData: basket });
  }

  shareItem(id) {
    if (this.props.inModal) {
      this.props.shareBasketItem();
    } else {
      this.setState({
        ModalShow: true,
        archiveBasket: false,
        shareBasket: true,
      });
    }
  }

  addItem(id, name, des) {
    if (des === null || des === "" || des === undefined) des = 0;
    this.setState((previousState) => ({
      basketData: [
        ...previousState.basketData,
        { id: id, lable: name, percent: des, Created: true, status: 2 },
      ],
      anyBasketVisible: true,
    }));
    setTimeout(this.scrolltobottom, 10);
  }

  scrolltobottom() {
    this.itemscontainer.scrollTop = this.itemscontainer.scrollHeight + 200;
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  archiveBasketYES() {
    this.deleteApi(this.state.currentBasketId);
  }

  shareBasketYES() {
    this.setState({
      ModalShow: false,
      archiveBasket: false,
      shareBasket: false,
    });
  }

  showHideItem(id, status) {
    let basket = this.state.basketData.slice(); //copy the array
    let anyBasketVisible = false;
    basket.forEach(function (entry) {
      if (entry.id === id) {
        let s;
        if (status) s = 2;
        else s = 3;
        entry.status = s;
        entry.Edited = true;
      }
      if (entry.status === 2) anyBasketVisible = true;
    });

    this.setState({ basketData: basket, anyBasketVisible: anyBasketVisible });
  }

  editedCall(id) {
    this.setState({ editedId: id });
  }

  saveBaskets(type) {
    try {
      let list = [];
      this.state.basketData.forEach(function (entry) {
        if (entry.Created !== undefined) {
          var d = {
            lable: entry.lable,
            status: entry.status,
            type: "insert",
            percent: entry.percent,
          };
          list.push(d);
        } else {
          if (entry.Edited !== undefined) {
            var dd = {
              lable: entry.lable,
              basket_id: entry.id,
              status: entry.status,
              type: "update",
              percent: entry.percent,
            };
            list.push(dd);
          }
        }
      });

      if (list.length === 0 && !this.props.inModal) {
        if (type === "back") this.props.onBasketBack();
        else this.props.onBasketNext();
        return;
      } else if (list.length === 0 && this.props.inModal) {
        this.props.hideModal();
        return;
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        list: list,
      };

      if (type === "back") {
        this.setState({ backButtonDisabled: true, backButtonSpinner: true });
      } else {
        this.setState({ buttonDisabled: true, buttonSpinner: true });
      }

      fetch("/api/createBasket", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.status >= 200 && result.status < 300) {
            if (this.props.inModal) this.props.hideModal();
            else {
              if (this.state.basketData.length > 0) {
                if (type === "back") {
                  this.props.onBasketBack();
                  return;
                } else {
                  this.props.onBasketNext();
                  return;
                }
              } else {
                alert("حداقل یک سبد باید داشته باشید");
              }
            }
          } else {
            alert("ارتباط با سرور برقرار نشد");
          }
          if (type === "back") {
            this.setState({
              backButtonDisabled: false,
              backButtonSpinner: false,
            });
          } else {
            this.setState({ buttonDisabled: false, buttonSpinner: false });
          }
        });
    } catch (error) {
      if (type === "back") {
        this.setState({ backButtonDisabled: false, backButtonSpinner: false });
      } else {
        this.setState({ buttonDisabled: false, buttonSpinner: false });
      }
    }
  }

  check1Change() {
    try {
      if (this.check1.checked) {
        this.setState({ buttonDisabledArchive: false });
      } else {
        this.setState({ buttonDisabledArchive: true });
      }
    } catch (error) {}
  }

  componentStatusChanged(edited) {
    try {
      if (this.props.inModal) {
        if (edited) {
          this.setState({ buttonDisabled: true });
        } else {
          this.setState({ buttonDisabled: false });
        }
      }
    } catch (error) {}
  }

  render() {
    // if (this.state.serverResponse){
    //     if (localStorage.getItem("token")===this.state.token){
    return (
      <div
        style={
          this.props.inModal
            ? {
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
              }
            : {
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                maxWidth: "450px",
                width: "97%",
                minHeight: "100vh",
                height: "100vh",
                maxHeight: "100vh",
              }
        }
      >
        {!this.props.inModal && (
          <div
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              display: "flex",
              padding: "0px",
              flexDirection: "column",
            }}
          >
            <img src={basketTitle} alt="logo" className="stepsLogo" />
            <div style={{ fontSize: "20px" }}>سبدهای خود را ایجاد کنید</div>
            {!this.props.inModal && (
              <div
                style={{
                  fontSize: "14px",
                  color: "var(--gray1)",
                  marginTop: "10px",
                }}
              >
                حداقل یک سبد باید وجود داشته باشد
              </div>
            )}
            {this.props.inModal && (
              <div
                style={{
                  fontSize: "14px",
                  color: "var(--gray1)",
                  marginTop: "10px",
                }}
              >
                حداقل یک سبد با حالت نمایش باید وجود داشته باشد
              </div>
            )}
          </div>
        )}

        {this.props.inModal && (
          <div
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              display: "flex",
              padding: "0px",
              flexDirection: "column",
            }}
          >
            <div style={{ fontSize: "20px" }}>لیست سبدها</div>
            <div
              style={{
                fontSize: "14px",
                color: "var(--gray1)",
                marginTop: "10px",
              }}
            >
              حداقل یک سبد با حالت نمایش باید وجود داشته باشد
            </div>
          </div>
        )}

        <div
          className={
            this.props.inModal
              ? "basketItemsContainer-modal"
              : "basketItemsContainer"
          }
        >
          <div
            ref={(scope) => (this.itemscontainer = scope)}
            className={
              this.props.inModal ? "itemscontainer-modal" : "itemscontainer"
            }
          >
            {this.state.basketData.length > 0 &&
              this.state.basketData.map((item, i) => (
                <BaksetItem
                  key={i}
                  componentStatus={this.componentStatusChanged.bind(this)}
                  type="default"
                  status={item.status === 2 ? true : false}
                  showHideEnable={this.props.inModal ? true : false}
                  showHide={this.showHideItem.bind(this)}
                  desHolder="درصد مشارکت سبد گردان"
                  editedStatus={
                    this.state.editedId !== null &&
                    this.state.editedId === item.id
                      ? true
                      : false
                  }
                  editedCall={this.editedCall.bind(this, item.id)}
                  isBasket={true}
                  showShare={this.props.inModal ? true : false}
                  itemId={item.id}
                  userBrokerList={this.state.basketData}
                  nameHolder="نام سبد"
                  name={item.lable}
                  description={item.percent}
                  delete={this.deleteItem.bind(
                    this,
                    item.id,
                    item.lable,
                    item.balance
                  )}
                  editItem={this.editItem.bind(this)}
                  share={this.shareItem.bind(this, item.id)}
                />
              ))}

            {this.state.isLoading && (
              <MagicSpinner size={70} color="var(--green1)" loading={true} />
            )}
          </div>
          <div style={{ width: "100%" }}>
            <BaksetItem
              componentStatus={this.componentStatusChanged.bind(this)}
              type="new"
              editedCall={this.editedCall.bind(this, 0)}
              editedStatus={
                this.state.editedId !== null && this.state.editedId === 0
                  ? true
                  : false
              }
              isBasket={true}
              userBrokerList={this.state.basketData}
              defaultText="افزودن یک سبد جدید"
              nameHolder="نام سبد"
              desHolder="درصد مشارکت سبد گردان"
              addItem={this.addItem.bind(this)}
            />
          </div>
        </div>

        {this.props.inModal && (
          <div className="popupButtons">
            <Button
              variant="primary"
              style={{ fontSize: "14px", margin: "5px" }}
              disabled={
                this.state.buttonDisabled ||
                this.state.basketData.length === 0 ||
                (this.state.basketData.length > 0 &&
                  !this.state.anyBasketVisible)
                  ? true
                  : false
              }
              onClick={this.saveBaskets}
            >
              {this.state.buttonSpinner && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonSpinner && <div>ذخیره</div>}
            </Button>
            <Button
              variant="danger"
              style={{ fontSize: "14px", margin: "5px" }}
              onClick={this.props.hideModal}
            >
              بستن
            </Button>
          </div>
        )}

        {this.props.showLogo && (
          <div style={{ width: "100%" }}>
            <div className="footerStyle">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "30px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    margin: "0px 7px",
                    backgroundColor: "var(--gray3)",
                    borderRadius: "50%",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    margin: "0px 7px",
                    backgroundColor: "var(--green1)",
                    borderRadius: "50%",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    margin: "0px 7px",
                    backgroundColor: "var(--gray3)",
                    borderRadius: "50%",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  marginBottom: "30px",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Button
                  onClick={this.backClick.bind(this)}
                  style={{ minWidth: "150px", fontSize: "14px" }}
                  disabled={this.state.backButtonDisabled}
                >
                  {this.state.backButtonSpinner && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.backButtonSpinner && <div>بازگشت</div>}
                </Button>
                <Button
                  variant="primary"
                  style={{ minWidth: "150px", fontSize: "14px" }}
                  disabled={
                    this.state.buttonDisabled ||
                    this.state.basketData.length === 0 ||
                    (this.state.basketData.length > 0 &&
                      !this.state.anyBasketVisible)
                      ? true
                      : false
                  }
                  onClick={this.nextClick.bind(this)}
                >
                  {this.state.buttonSpinner && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.buttonSpinner && <div>مرحله بعد</div>}
                </Button>
              </div>
            </div>
          </div>
        )}

        <Modal
          show={this.state.ModalShow}
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
          // backdrop={this.state.modalBackDrop}
        >
          {this.state.archiveBasket && (
            <div className="popup">
              <div style={{ marginBottom: "10px" }}>
                آیا مطمئن به حذف سبد هستید؟
              </div>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  color: "var(--textcolor1)",
                }}
              >
                &nbsp;"&nbsp;{this.state.currentBasketName}&nbsp;"&nbsp;
              </div>
              <CheckBoxComponent
                className="checkBoxContainer"
                label="اطلاعات سبد بعد از حذف غیرقابل برگشت است و شرایط را قبول دارم"
                ref={(scope) => (this.check1 = scope)}
                change={this.check1Change.bind(this)}
                enableRtl="true"
              />
              <div className="popupButtons">
                <Button
                  variant="primary"
                  disabled={this.state.buttonDisabledArchive}
                  style={{ fontSize: "14px", margin: "5px" }}
                  onClick={this.archiveBasketYES.bind(this)}
                >
                  بله
                </Button>
                <Button
                  variant="danger"
                  style={{ fontSize: "14px", margin: "5px" }}
                  onClick={this.hideModal.bind(this)}
                >
                  خیر
                </Button>
              </div>
            </div>
          )}

          {this.state.shareBasket && (
            <div className="popup">
              <div
                style={{
                  width: "100%",
                  textAlign: "right",
                  marginBottom: "7px",
                }}
              >
                لطفاً شماره تلفن همراه شخصی که میخواهید این سبد را با او به
                اشتراک بگذارید را وارد کنید
              </div>
              <Form.Control
                type="text"
                ref={(scope) => {
                  this.shareBasketText = scope;
                }}
                enableRtl={true}
                style={{ textAlign: "right", fontSize: "14px" }}
                placeholder="شماره تلفن همراه"
              />
              <div className="popupButtons">
                <Button
                  variant="primary"
                  style={{ fontSize: "14px", margin: "5px" }}
                  onClick={this.shareBasketYES.bind(this)}
                >
                  اشتراک گذاری
                </Button>
                <Button
                  variant="danger"
                  style={{ fontSize: "14px", margin: "5px" }}
                  onClick={this.hideModal.bind(this)}
                >
                  انصراف
                </Button>
              </div>
            </div>
          )}
        </Modal>
        {this.state.apiHasError && <Redirect to="/Login" />}
      </div>
    );
  }
}
